/** This file is auto generated by convertSvgToJsx.ts */

import icon from './dnb/graph_increase_medium'
export default icon
